'use strict';

var y = require('yup');

function _interopNamespaceCompat(e) {
  if (e && typeof e === 'object' && 'default' in e) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var y__namespace = /*#__PURE__*/_interopNamespaceCompat(y);

const name = 'clabe';
const CLABE_ERROR = 'invalidClabe';
function isValid(clabeNumber) {
    // remove separators from string, only verify the number
    clabeNumber = clabeNumber.replaceAll(/ /g, '');
    // Check if the input is exactly 18 digits long
    if (clabeNumber.length !== 18 || !/^\d{18}$/.test(clabeNumber)) {
        return false;
    }
    // Calculate the checksum from the first 17 digits
    // https://en.wikipedia.org/wiki/CLABE#Control_digit
    const checksum = clabeNumber.slice(0, 17).split('').reduce((sum, digit, i)=>{
        const weight = [
            3,
            7,
            1
        ][i % 3];
        return sum + Number(digit) * weight % 10;
    }, 0);
    // Check if the last digit matches the calculated checksum
    return (10 - checksum % 10) % 10 === Number(clabeNumber.slice(17));
}
y__namespace.addMethod(y__namespace.StringSchema, name, function(options) {
    return this.test({
        name,
        message: {
            key: options?.error ?? CLABE_ERROR
        },
        test: (value)=>{
            if (!value) {
                return false;
            }
            return isValid(value);
        }
    });
});

exports.CLABE_ERROR = CLABE_ERROR;
//# sourceMappingURL=clabe.js.map
